module.exports = __webpack_public_path__ + "static/img/11495-detailp.2ffd9c3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/oevp/11495-detailp.jpeg
// module id = 195
// module chunks = 1